interface RegistrationsClosedNoticeProps {
  className?: string;
}

export default function RegistrationsClosedNotice({ className = "" }: RegistrationsClosedNoticeProps) {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary/10 via-beige to-nude/40 border-2 border-primary/25 p-px ${className}`}
    >
      <div className="rounded-2xl bg-gradient-to-br from-primary/5 via-white to-beige/60 p-5 md:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="relative shrink-0">
            <div className="absolute inset-0 rounded-full bg-primary/20 blur-xl" />
            <div className="relative w-14 h-14 rounded-full bg-primary/15 border-2 border-primary/30 flex items-center justify-center">
              <i className="ri-lock-line text-2xl text-primary" />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary text-white font-body text-[11px] font-bold tracking-wider uppercase mb-2">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-lock-line text-xs" />
              </div>
              Inscrições encerradas
            </div>
            <p className="font-body text-sm text-brown font-semibold mb-1">
              As inscrições para este encontro já foram encerradas.
            </p>
            <p className="font-body text-[13px] text-brown/60 leading-snug">
              Fique de olho na nossa página e nas redes sociais — em breve teremos novas datas para nos encontrarmos!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}